import "./index.scss";

import MainComponent from "@src/MainComponent";

function DashboardPage(props: any) {
  return (
    <MainComponent>
      <div className="app__dashboard">
        <h2>Dashboard</h2>
      </div>
    </MainComponent>
  );
}

export default DashboardPage;
